import { initLoginoutBtn } from "./loginout_btn";
import { initDisplaySettings } from "./display_settings";
import { initMatomoTracker } from "./matomo";
import { initMenuOverlay } from "./menu_overlay";
import { initCourseCollapse } from "./course_collapse";

const FLAVOUR = process.env.FLAVOUR;

export const init = () => {
    initLoginoutBtn();
    initDisplaySettings();
    initMatomoTracker();
    initMenuOverlay();

    //TODO: refactor and init certain librarys here by flavour (e.g. course collapse)
    switch(FLAVOUR) {
        case "moodle":
            initCourseCollapse();
            break;
        default:
    }
}
